<template>
  <div class="button-container">
    <a href="https://github.com/televo/kingdom-hearts-recollection/releases/download/v6.0/Kingdom-Hearts-ReCollection.zip" :class="{ disabled: isClicked }">
      <button class="download" @click="playPopupAudio" :class="{ thanks: isClicked }">
        <img src="../assets/Glove.png" id="glove" alt=""/>
        <div id="light"></div>
        <h2 class="download-text">{{ buttonText }}</h2>
      </button>
    </a>
  </div>
</template>

<script>
import popupSound from "@/assets/audio/popup.mp3";
export default {
  name: 'DownloadButton',
  data() {
    return {
      buttonText: 'Download Re:Collection',
      isClicked: false,
    };
  },
  mounted() {
    this.updateButtonText();
    window.addEventListener('resize', this.updateButtonText);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateButtonText);
  },
  methods: {
    updateButtonText() {
      if (window.innerWidth <= 490) {
        this.buttonText = 'Download';
      } else {
        this.buttonText = 'Download Re:Collection';
      }
    },
    playPopupAudio() {
      const popupAudio = new Audio(popupSound);
      popupAudio.play();
      if (window.innerWidth <= 490) {
        this.buttonText = 'Thanks';
      } else {
        this.buttonText = 'Thank You, Kupo';
      }
      setTimeout(() => {
        this.isClicked = true;
      }, 100);
    },
  },
};
</script>

<style scoped>
.download {
  animation: download 3.5s infinite ease-in-out;
  padding: calc(0.5em + 0.1vw) calc(2em + 1vw);
  user-select: none;
}
@keyframes download {
  50% { transform: scale(1.05); }
}
.thanks {
  background: var(--blue-light);
  border: solid 2px var(--blue-light);
  color: var(--indigo);
}
.disabled {
  pointer-events: none;
}
#glove {
  position: absolute;
  left: calc(-4em + -2vw);
  width: calc(4em + 2vw);
  height: calc(4em + 2vw);
  filter: drop-shadow(0.25em 0.25em 0.5em var(--indigo));
  animation: glove 2s infinite ease-in-out;
  z-index: 5;
}
@keyframes glove {
  50% { transform: translateX(1em); }
}
#light {
  position: absolute;
  top: calc(-2.5em + -1vw);
  right: calc(-2.5em + -1vw);
  width: calc(6em + 2vw);
  height: calc(6em + 2vw);
  background: url("../assets/Light.png") no-repeat 100% 0 / 50%;
  animation: light 10s infinite ease-in-out alternate;
  z-index: 5;
  mix-blend-mode: screen;
}
@keyframes light {
  0% { transform: rotate(-20deg) translateX(-1em) translateY(1em) scale(0.9);}
  25% { transform: rotate(10deg) scale(1.1);; }
  75% { transform: rotate(220deg) scale(0.9); }
  100% { transform: rotate(250deg) translateX(-1.25em) translateY(1.25em) scale(1.1); }
}
</style>